import App from "../../app/indexDesktop";
import AsyncHome, { loadData as loadHomeData } from "../../pages/Home/Desktop";
import AsyncBaiduHome from "../../pages/BaiduHome/Desktop/index";
import AsyncPropertyPage, {
  loadData as loadPropertyData,
  PreFetchPropertyPage,
} from "../../pages/PropertyPage/Desktop";
import AsyncVideoPage, { loadData as loadVideoPageData } from "../../pages/VideoPage";
import AsyncSearch, { loadData as loadSeachData, PreFetchSearch } from "../../pages/Search/Desktop";
import AsyncNearby from "../../pages/Nearby";
import AsyncBookForm, { loadData as loadBookFormData, PreFetchBookForm } from "pages/BookForm";
import NotFound from "../../pages/NotFound";
import AsyncProfilePage from "../../pages/Profile/Desktop";
import AsyncBookingsPage from "../../pages/Bookings/Desktop";
import AsyncBookingsDetailsPage, {
  loadData as loadBookingDetailsData,
} from "../../pages/BookingDetails/Desktop";
import AsyncCashbackSupportPage from "../../pages/CashbackSupport";
import AsyncOffersPage from "../../pages/Offers/Desktop";
import AsyncPersonalInfoPage from "../../pages/ThirdPartyInfo/Desktop";
import AsyncBlogPostPage from "../../pages/Blog/BlogPost";
import AsyncBlogGridPage from "../../pages/Blog/BlogGrid";
import AsyncBlogHomePage from "../../pages/Blog/BlogHome";
import loadBlogData from "../../pages/Blog/data/loadData";
import { newsMiddlewareServer } from "@Pages/News/NewsPost/data/newsPageReducer";
import AsyncNewsHomePage from "../../pages/News/NewsHome";
import AsyncNewsGridPage from "../../pages/News/NewsGrid";
import AsyncNewsPostPage from "../../pages/News/NewsPost";
import loadNewsData from "../../pages/News/data/loadData";
import AsyncUniversityPage, {
  loadData as loadUniversityPageData,
} from "../../pages/UniversityPage/Desktop";
import AsyncAmberPlus, { loadData as loadAmberPlusData } from "../../pages/AmberPlus/Desktop";
import AsyncAmberPlusCross, {
  loadData as loadAmberPlusCrossData,
} from "../../pages/AmberPlusCross/Desktop";
import AsyncAmberPlusCategories, {
  loadData as loadAmberPlusCategoriesData,
} from "../../pages/PlusCategories/Desktop";
import {
  appBannerMiddleware,
  authMiddlewareServer,
  dispatchCookies,
  dispatchMetaIndexTag,
  gridViewMiddleware,
  abTestMiddleware,
  chinaLanguageModalMiddleWare,
  tolgeeMiddleWare,
  tolgeeClientMiddleware,
  userCurrencyExchangeMiddleware,
} from "@App/appReducer";
import AsyncPaymentForm from "../../pages/Payment";
import AsyncPaymentFormSuccess from "../../pages/Payment/components/PaymentSuccess/index";
import AsyncCustomPayment from "../../pages/Payment/components/CustomPayment";
import AsyncReferralProgramPage from "../../pages/Referral/Desktop";
import AsyncProfileReferPage from "../../pages/ProfileRefer/Desktop";
import BookFromSuccess from "@Pages/BookForm/components/BookformSuccess";
import loadPaymentSuccessData from "@Pages/BookForm/data/loadPaymentSuccessData";
import AsyncShortlistPage from "../../pages/Shortlist/Desktop";
import AsyncSupportPage from "../../pages/Support";
import { whitelabelMiddlewareServer } from "@App/whiteLabelReducer";
import AsyncListPage from "../../pages/List/Desktop";
import AsyncTermsPage from "../../pages/Terms";
import AsyncPrivacyPage from "../../pages/Privacy";
import loadCustomPaymentData from "@Pages/BookForm/data/leadCustomPaymentData";
import ApplicationForm from "@Pages/ApplicationForm";
import AsyncUserReviewScreen from "../../pages/UserReviewScreen";
import { blogMiddlewareServer } from "@Pages/Blog/BlogPost/data/blogPageReducer";
import AsyncAmberUserServiceAgreement from "../../pages/AmberUserServiceAgreement/Desktop";
import AsyncPersonalInfoSharingList from "../../pages/PersonalInfoSharingList/Desktop";
import AsyncAmberApp from "../../pages/AmberApp";
import AsyncSettingsPage from "../../pages/Settings";
import AsyncAboutPage from "../../pages/About";
import AsyncMediaMentionsPage from "../../pages/MediaMentions/desktop";
import AsyncAmbassador from "../../pages/Ambassador";
import AsyncScholarship from "../../pages/Scholarship/Desktop";
import AsyncExams from "../../pages/Exams";
import AsyncExamsPostPage, { loadData as loadExamsData } from "../../pages/Exams/ExamsPost";
import AsyncCareer from "../../pages/Career";
import AsyncJobs from "../../pages/Jobs";
import AsyncPodcastPage from "../../pages/Podcast/desktop";
import AsyncContactPage from "../../pages/Contact/desktop";
import AsyncHowItWorksPage from "../../pages/HowItWorks/desktop";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import { iframeDetectionMiddlewareServer } from "@App/iframeReducer";
import LanguageFallbackRedirect from "@Utils/languageFallbackRedirect";
import { languageFromUrlMiddleware } from "@Utils/languageReduxHelpers";

const routesConfig = [
  {
    component: App,
    routes: [
      {
        path: ["/", "/:lang(es|de|fr)/"],
        exact: true,
        component: AsyncHome,
        loadData: loadHomeData,
        moduleName: APP_PAGE.HOME,
        prefetch: [PreFetchPropertyPage, PreFetchSearch],
        tagforkey: ["home"],
        ssrSMaxAge: [14400, 14400],
        ssrStaleWhileRevalidate: [345600, 345600],
      },
      {
        path: "/index",
        exact: true,
        component: AsyncBaiduHome,
      },
      {
        path: ["/places/search/:id/agent-view", "/:lang(es|de|fr)/places/search/:id/agent-view"],
        redirect: true,
        redirectUrl: ({ id }: any) => `/places/search/${id}`,
        tagforkey: ["property", "search"],
      },
      {
        path: ["/nearby", "/:lang(es|de|fr)/nearby"],
        exact: true,
        component: AsyncNearby,
        moduleName: "NearbyPage",
        tagforkey: ["nearby"],
      },
      {
        path: ["/places/search/:id", "/:lang(es|de|fr)/places/search/:id"],
        component: AsyncSearch,
        loadData: loadSeachData,
        moduleName: "SearchPage",
        tagforkey: ["search"],
        ssrSMaxAge: [20000, 172800],
        ssrStaleWhileRevalidate: [86400, 172800],
        ssrCacheQueryOverrides: [
          {
            when: { query: { p: { present: true } } },
            ssrStaleWhileRevalidate: 604800, // 7 days for paginated search
          },
        ],
      },
      {
        path: ["/places/:id/form", "/:lang(es|de|fr)/places/:id/form"],
        loadData: loadBookFormData,
        component: AsyncBookForm,
        loadClarity: true,
        tagforkey: ["bookform"],
      },
      {
        path: ["/places/:id/application", "/:lang(es|de|fr)/places/:id/application"],
        loadData: loadBookFormData,
        component: ApplicationForm,
        loadClarity: true,
        tagforkey: ["bookform"],
      },
      {
        path: ["/forms/submit", "/:lang(es|de|fr)/forms/submit"],
        loadData: loadPaymentSuccessData,
        component: BookFromSuccess,
        tagforkey: ["bookform"],
      },
      {
        path: ["/places/:id/payment", "/:lang(es|de|fr)/places/:id/payment"],
        loadData: loadBookFormData,
        component: AsyncPaymentForm,
        loadClarity: true,
        tagforkey: ["payment", "bookform"],
      },
      {
        path: ["/payments/complete", "/:lang(es|de|fr)/payments/complete"],
        loadData: loadPaymentSuccessData,
        component: AsyncPaymentFormSuccess,
        tagforkey: ["payment"],
      },
      {
        path: ["/payments/:token", "/:lang(es|de|fr)/payments/:token"],
        loadData: loadCustomPaymentData,
        component: AsyncCustomPayment,
        tagforkey: ["payment"],
      },
      {
        path: ["/places/:id/agent-view", "/:lang(es|de|fr)/places/:id/agent-view"],
        redirect: true,
        redirectUrl: ({ id }: any) => `/places/${id}`,
        tagforkey: ["property"],
      },
      {
        path: [
          "/places/:id/video/:videoId",
          "/places/:id/video",
          "/:lang(es|de|fr)/places/:id/video/:videoId",
          "/:lang(es|de|fr)/places/:id/video",
        ],
        loadData: loadVideoPageData,
        component: AsyncVideoPage,
        tagforkey: ["property"],
      },
      {
        path: ["/places/:id", "/:lang(es|de|fr)/places/:id"],
        loadData: loadPropertyData,
        component: AsyncPropertyPage,
        prefetch: [PreFetchBookForm],
        tagforkey: ["property"],
        ssrSMaxAge: [15000, 172800],
        ssrStaleWhileRevalidate: [172800, 172800],
      },
      {
        path: ["/profile/shortlist", "/:lang(es|de|fr)/profile/shortlist"],
        exact: true,
        component: AsyncShortlistPage,
        tagforkey: ["shortlist"],
      },
      {
        path: ["/profile/offers", "/:lang(es|de|fr)/profile/offers"],
        exact: true,
        component: AsyncOffersPage,
        tagforkey: ["offers"],
      },
      {
        path: "/third-party-personal-info",
        exact: true,
        component: AsyncPersonalInfoPage,
      },
      {
        path: ["/profile/refer", "/:lang(es|de|fr)/profile/refer"],
        exact: true,
        component: AsyncProfileReferPage,
        tagforkey: ["referral"],
      },
      {
        path: "/plus/service/&isWebView=true",
        exact: true,
        component: AsyncAmberPlus,
        loadData: loadAmberPlusData,
        redirect: true,
      },
      {
        path: "/plus",
        exact: true,
        component: AsyncAmberPlus,
        loadData: loadAmberPlusData,
      },
      {
        path: ["/plus-cross", "/plus-cross/:service"],
        exact: true,
        component: AsyncAmberPlusCross,
        loadData: loadAmberPlusCrossData,
        tagforkey: ["pluscross"],
      },
      {
        path: "/plus/service/:id",
        exact: true,
        component: AsyncAmberPlusCategories,
        loadData: loadAmberPlusCategoriesData,
      },
      {
        path: ["/referral-programme", "/:lang(es|de|fr)/referral-programme"],
        exact: true,
        component: AsyncReferralProgramPage,
        tagforkey: ["referral", "home"],
      },
      {
        path: ["/profile", "/:lang(es|de|fr)/profile"],
        exact: true,
        component: AsyncProfilePage,
        tagforkey: ["profile"],
      },
      {
        path: ["/profile/leads", "/:lang(es|de|fr)/profile/leads"],
        exact: true,
        component: AsyncBookingsPage,
        tagforkey: ["bookings"],
      },
      {
        path: ["/profile/leads/:id", "/:lang(es|de|fr)/profile/leads/:id"],
        exact: true,
        component: AsyncBookingsDetailsPage,
        loadData: loadBookingDetailsData,
        tagforkey: ["bookings"],
      },
      {
        path: ["/profile/support", "/:lang(es|de|fr)/profile/support"],
        exact: true,
        component: AsyncSupportPage,
        tagforkey: ["generic"],
      },
      {
        path: ["/profile/leads/support", "/:lang(es|de|fr)/profile/leads/support"],
        exact: true,
        component: AsyncCashbackSupportPage,
        tagforkey: ["generic"],
      },
      {
        path: [
          "/profile/review/upload/:inventoryId(\\d+)",
          "/:lang(es|de|fr)/profile/review/upload/:inventoryId(\\d+)",
        ],
        exact: true,
        component: AsyncUserReviewScreen,
        tagforkey: ["generic"],
      },
      {
        path: ["/list", "/:lang(es|de|fr)/list"],
        exact: true,
        component: AsyncListPage,
        tagforkey: ["generic", "list"],
      },
      {
        path: "/amberapp",
        exact: true,
        component: AsyncAmberApp,
      },
      {
        path: ["/about", "/:lang(es|de|fr)/about"],
        exact: true,
        component: AsyncAboutPage,
        tagforkey: ["about"],
      },
      {
        path: ["/media", "/:lang(es|de|fr)/media"],
        exact: true,
        component: AsyncMediaMentionsPage,
        tagforkey: ["media"],
      },
      {
        path: "/amber-user-service-agreement",
        exact: true,
        component: AsyncAmberUserServiceAgreement,
      },
      {
        path: "/podcast",
        exact: true,
        component: AsyncPodcastPage,
        tagforkey: ["generic"],
      },
      {
        path: "/contact",
        exact: true,
        component: AsyncContactPage,
        tagforkey: ["generic"],
      },
      {
        path: ["/how-it-works", "/:lang(es|de|fr)/how-it-works"],
        exact: true,
        component: AsyncHowItWorksPage,
        tagforkey: ["generic", "home", "howitworks"],
      },
      {
        path: ["/terms", "/:lang(es|de|fr)/terms"],
        exact: true,
        component: AsyncTermsPage,
        tagforkey: ["terms"],
      },
      {
        path: "/personal-info-sharing-list",
        exact: true,
        component: AsyncPersonalInfoSharingList,
      },
      {
        path: ["/privacy", "/:lang(es|de|fr)/privacy"],
        exact: true,
        component: AsyncPrivacyPage,
        tagforkey: ["privacy"],
      },
      {
        path: ["/blog", "/:lang(es|de|fr)/blog"],
        exact: true,
        component: AsyncBlogHomePage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_HOME,
        ssrSMaxAge: 43200,
        tagforkey: ["blog"],
      },
      {
        path: ["/blog/latest", "/:lang(es|de|fr)/blog/latest"],
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_GRID,
        tagforkey: ["blog"],
      },
      {
        path: ["/blog/post/:slug", "/:lang(es|de|fr)/blog/post/:slug"],
        exact: true,
        component: AsyncBlogPostPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_POST,
        tagforkey: ["blog"],
      },
      {
        path: ["/blog/category/:slug", "/:lang(es|de|fr)/blog/category/:slug"],
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_CATEGORY,
        tagforkey: ["blog"],
      },
      {
        path: ["/blog/tag/:slug", "/:lang(es|de|fr)/blog/tag/:slug"],
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_TAG,
        tagforkey: ["blog"],
      },
      {
        path: ["/blog/search", "/:lang(es|de|fr)/blog/search"],
        exact: true,
        component: AsyncBlogGridPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_SEARCH,
        tagforkey: ["blog"],
      },
      {
        path: "/drafts-blog/post/:slug",
        exact: true,
        component: AsyncBlogPostPage,
        loadData: loadBlogData,
        moduleName: APP_PAGE.BLOG_DRAFTS,
      },
      {
        path: "/news",
        exact: true,
        component: AsyncNewsHomePage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_HOME,
        tagforkey: ["news"],
        ssrSMaxAge: 43200,
      },
      {
        path: "/news/latest",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_GRID,
        tagforkey: ["news"],
      },
      {
        path: "/news/post/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_POST,
        tagforkey: ["news"],
      },
      {
        path: "/news/amberreport/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_AMBER_REPORT,
        tagforkey: ["news"],
      },
      {
        path: "/news/amberbeat/:slug",
        exact: true,
        component: AsyncNewsPostPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_AMBER_BEAT,
        tagforkey: ["news"],
      },
      {
        path: "/news/category/:slug",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_CATEGORY,
        tagforkey: ["news"],
      },
      {
        path: "/news/tag/:slug",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_TAG,
        tagforkey: ["news"],
      },
      {
        path: "/news/search",
        exact: true,
        component: AsyncNewsGridPage,
        loadData: loadNewsData,
        moduleName: APP_PAGE.NEWS_SEARCH,
        tagforkey: ["news"],
      },
      {
        path: ["/ambassador", "/:lang(es|de|fr)/ambassador"],
        exact: true,
        component: AsyncAmbassador,
        tagforkey: ["ambassador"],
      },
      {
        path: "/exams",
        exact: true,
        component: AsyncExams,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: "/exams/:examName/:slug",
        exact: true,
        component: AsyncExamsPostPage,
        loadData: loadExamsData,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: "/drafts-exams/:examName/:slug",
        exact: true,
        component: AsyncExamsPostPage,
        loadData: loadExamsData,
        moduleName: APP_PAGE.EXAMS,
      },
      {
        path: ["/scholarship", "/:lang(es|de|fr)/scholarship"],
        exact: true,
        component: AsyncScholarship,
        moduleName: APP_PAGE.SCHOLARSHIP,
        tagforkey: ["generic, scholarship"],
      },
      {
        path: ["/career", "/:lang(es|de|fr)/career"],
        exact: true,
        component: AsyncCareer,
        tagforkey: ["career"],
      },
      {
        path: "/job-opening",
        exact: true,
        component: AsyncJobs,
      },
      {
        path: "/universitypage/:slug",
        exact: true,
        component: AsyncUniversityPage,
        loadData: loadUniversityPageData,
      },
      {
        path: "/profile/settings",
        exact: true,
        component: AsyncSettingsPage,
        moduleName: APP_PAGE.SETTINGS,
      },
      // Language fallback redirect - catches invalid language routes
      {
        path: "/:lang(es|de|fr)/*",
        component: LanguageFallbackRedirect,
      },
      {
        component: NotFound,
      },
    ],
    rootData: (props: any) => [
      languageFromUrlMiddleware(props), // Must run first to set language from URL
      authMiddlewareServer(props),
      appBannerMiddleware(props),
      dispatchCookies(props),
      dispatchMetaIndexTag(props),
      gridViewMiddleware(props),
      abTestMiddleware(props),
      chinaLanguageModalMiddleWare(props),
      tolgeeMiddleWare(props),
      tolgeeClientMiddleware(props),
      userCurrencyExchangeMiddleware(props),
    ],
    preFetchData: (props: any) => [
      whitelabelMiddlewareServer(props),
      blogMiddlewareServer(props),
      newsMiddlewareServer(props),
      iframeDetectionMiddlewareServer(props),
    ],
  },
] as any;

export default routesConfig;
